// eslint-disable-next-line max-len
var TIME_LOCATION_MAIN_CENTER = 'M20.5,6h-9V4h9Zm0,4h-9v2h9Zm0,6h-9v2h9ZM28,12H26v2h2Zm0,6H26v2h2Zm0,6H26v2h2ZM6,12H4v2H6Zm0,6H4v2H6Zm0,6H4v2H6ZM32,6V32H0V6H8V0H24V6ZM8,8H2V30H8Zm3.5,22V21h9v9H22V2H10V30Zm2,0h5V23h-5ZM30,8H24V30h6Z';

export { TIME_LOCATION_MAIN_CENTER };
//# sourceMappingURL=TIME_LOCATION_MAIN_CENTER.js.map
